'use client';

import { type ChangeEvent, useEffect, useState } from 'react';

import { useProductStore } from '@/presenters/store/catalog/product';
import { useGlobalStore } from '@/presenters/store/global';

import { formatZipCode, zipCodeIsValid as zipCodeIsValidUtil } from './utils';

export default function useZipCode() {
  const defaultZipCode = useGlobalStore((store) => store.session?.zipCode);

  const [zipCode, setZipCode] = useState('');

  const {
    ecommerceScopes: { canPurchase },
  } = useProductStore((store) => store.currentSeller);

  const zipCodeIsDisabled = !canPurchase;
  const zipCodeIsValid = zipCodeIsValidUtil(zipCode);
  const clearZipCode = () => setZipCode('');

  useEffect(() => {
    if (defaultZipCode && !zipCodeIsDisabled) {
      setZipCode(defaultZipCode);
    }
  }, [defaultZipCode, zipCodeIsDisabled]);

  const onChangeZipCode = (event: ChangeEvent<HTMLInputElement>) => {
    event.stopPropagation();
    const zipCode = formatZipCode(event.target.value);

    setZipCode(zipCode);
  };

  return {
    zipCode,
    zipCodeIsDisabled,
    onChangeZipCode,
    zipCodeIsValid,
    clearZipCode,
  };
}
